import { IReport, ReportStatus, ReportType } from '@/types/Reports/Reports.types';
import { ClinicalStatus } from '@/types/MTB/ClinicalStatus.types';
import { CaseStatus, PseudoStatus } from '@/types/TaskDashboard/TaskDashboard.types';
import { REPORT_STATUS } from '@/constants/Dashboard/DataGrid/dataGrid.constants';

export const mapReportStatus = (
  reportType: ReportType,
  status: ReportStatus | PseudoStatus | undefined,
  isGermlineOnly: boolean,
  isHighRisk: boolean,
  molecularReport?: IReport | null,
  clinicalPseudoStatus?: PseudoStatus | null,
  clinicalStatus?: ClinicalStatus,
): CaseStatus => {
  switch (status) {
    case REPORT_STATUS.PENDING:
      return 'In Progress';
    case REPORT_STATUS.FINALISED:
      return 'Finalised';
    case REPORT_STATUS.READY_TO_SEND:
      return 'Ready to Send';
    case REPORT_STATUS.SENDING:
      return 'Sending';
    case REPORT_STATUS.SENT:
      return 'Sent';
    case REPORT_STATUS.FAILED:
      return 'Failed';
    case REPORT_STATUS.DONE:
      return 'Done';
    case REPORT_STATUS.REJECTED:
    case REPORT_STATUS.CANCELLED:
      return 'Upcoming';
    case undefined:
      if (reportType === 'MTB_REPORT') {
        if (clinicalPseudoStatus === 'N/A' || clinicalStatus === 'N/A') return 'N/A';
        if (clinicalStatus) return 'Upcoming';
      }
      if (
        (reportType === 'MOLECULAR_REPORT' && isGermlineOnly)
        || (reportType === 'MTB_REPORT'
          && (
            !isHighRisk
            || molecularReport?.metadata?.['molecular.hidePanel'] === 'true'
            || isGermlineOnly))
        || (reportType === 'PRECLINICAL_REPORT')
      ) return 'N/A';
      return 'Upcoming';
    default:
      return status;
  }
};
